<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.95 18.95">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          id="Path_975"
          data-name="Path 975"
          class="cls-1"
          d="M9.48,0A9.48,9.48,0,1,0,19,9.48h0A9.47,9.47,0,0,0,9.48,0Zm4.81,10.51H4.66a1,1,0,1,1,0-2.07h9.64a1,1,0,1,1,0,2.07Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
